<template>
  <div class="image-album">
    <form-file :name="`file_${index}`" uploadFront="true" folder="audiobooks"/>
    <form-input :name="`name_${index}`"/>
  </div>
</template>

<script>
  import {createNamespacedHelpers} from 'vuex'
  import FormInput from '@/components/create-form/Input'
  import FormFile from '@/components/create-form/File'

  const {mapMutations, mapActions, mapState, mapGetters} = createNamespacedHelpers('mainPage');

  export default {
    name: "Audio",
    props: ['index'],
    data() {
      return {}
    },
    computed: {
      ...mapState([
        'isError',
        'fields'
      ])
    },
    methods: {
      ...mapMutations([
        'setIsError',
        'setFileExtension',
        'setInitFields',
        'deleteField'
      ]),
      ...mapActions([
        'initField'
      ])
    },
    created() {
      this.setFileExtension({name: `file_${this.index}`, value: ['mp3', 'wma', 'acc']})
      let savedData = {};
      if (localStorage.hasOwnProperty(this.$route.path)) {
        savedData = JSON.parse(localStorage.getItem(this.$route.path))
      }
      this.initField({index: this.index, name: 'name_', value: {
          value: savedData.hasOwnProperty(`name_${this.index}`)? savedData[`name_${this.index}`] : '',
          parameterName: 'name',
          name: 'Название аудиофайла',
          errorId: null,
          type: 'audio-name',
          errors: {empty: 'Введите подпись изображение'},
          tabId: 0,
        }
      })
      this.initField({index: this.index, name: 'file_', value: {
          value: savedData.hasOwnProperty(`file_${this.index}`)? savedData[`file_${this.index}`] : '',
          parameterName: 'file',
          name: 'Аудиофайл',
          errorId: null,
          type: 'audio-file',
          errors: {empty: 'Загрузите аудиофайл', extension: 'Допустимые расширения: mp3, wma, acc'},
          fileName: '',
          tabId: 0,
        }
      })
    },
    beforeDestroy() {
      this.deleteField(`file_${this.index}`);
      this.deleteField(`name_${this.index}`);
    },
    components: {
      FormFile,
      FormInput
    }
  }
</script>

<style scoped>
  .block {
    padding: 15px;
    border-radius: 5px;
    border: 1px solid #e4e8eb;
    margin-bottom: 15px;
  }
</style>



// WEBPACK FOOTER //
// src/components/create-form/Audio.vue